import { useContext } from "react";
import LicensePlatesContext from "../context/LicensePlatesContext";

const useLicensePlates = () => {
    const {
        licensePlatesToExclude,
        fetchLicensePlatesToExclude
    } = useContext(LicensePlatesContext)

    return {
        licensePlatesToExclude,
        fetchLicensePlatesToExclude
    };
}

export default useLicensePlates;